import Vue from 'vue'
import Vuex from 'vuex'
// chamadas a API
import requests from "../requests/index";
// constantes do sistema
import constants from "../constants/index";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        count: 0,
        requests: requests,
        constants: constants,
        loading: false,
        msgs: [],
        tokenCaptcha: null,
        nome: "",
        cpf: "",
        beneficios: [],
        familia: {},
        dadosAluno: {},
        dadosSupermercado: {},
        retornoComDados: false,
        lstBeneficiarios: [],
        lstHistoricoVouchers: [],
        termoBuscaCpf: "",
        termoBuscaNome: "",
        termoBuscaCpfHist: "",
        showScreen: true,
        dadosForm: {}
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        increment(state) {
            state.count++
        },
        registraRetornoComDados(state, retornoComDados) {
            Vue.set(state, "retornoComDados", retornoComDados);
        },
        registraCpf(state, cpf) {
            state.cpf = cpf;
        },
        registraNome(state, nome) {
            state.nome = nome;
        },
        registraBeneficios(state, beneficios) {
            state.beneficios = beneficios;
        },
        registraFamilia(state, familia) {
            state.familia = familia;
        },
        limpaDados(state) {
            state.cpf = "";
            state.nome = "";
            state.beneficios = [];
            state.familia = {};
            state.dadosAluno = [];
            state.dadosSupermercado = [];
            state.retornoComDados = false;
            state.dadosForm = {};
        },
        setShowScreen(state, show) {
            state.showScreen = show;
        },
        setDadosForm(state, dadosForm) {
            state.dadosForm = dadosForm;
        }
    },
    actions: {
        gravaDadosForm({ commit }, { nome, cpf, beneficios, familia }) {
            commit("registraCpf", cpf);
            commit("registraNome", nome);
            commit("registraBeneficios", beneficios);
            commit("registraFamilia", familia);
        },
        flushDados({ commit }) {
            commit("limpaDados");
        },
    },
    getters: {
        http: state => state.requests, 
        const: state => state.constants,
        loading: (state) => state.loading,
        tokenCaptcha: (state) => state.tokenCaptcha,
        cpf: (state) => state.cpf,
        nome: (state) => state.nome,
        beneficios: (state) => state.beneficios,
        familia: (state) => state.familia,
        retornoComDados: (state) => state.retornoComDados,
        lstBeneficiarios: (state) => state.lstBeneficiarios,
        lstHistoricoVouchers: (state) => state.lstHistoricoVouchers,
        termoBuscaCpf: (state) => state.termoBuscaCpf,
        termoBuscaNome: (state) => state.termoBuscaNome,
        termoBuscaCpfHist: (state) => state.termoBuscaCpfHist,
        showScreen: (state) => state.showScreen,
        dadosForm: (state) => state.dadosForm
    }
})
